import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import moment from 'moment'
import { useState } from 'react'
import styles from './ShortDatePicker.module.sass'

const ShortDatePicker = (props) => {
	const { onChange, initialDate } = props

	const [date, setDate] = useState(initialDate || moment())

	return (
		<div className={styles['date-container']}>
			<label className={styles['date-input']}>
				<Icon
					className={styles['icon']}
					name='calendar'
					width='18px'
					height='18px'
				/>
				<input
					tabIndex='-1'
					type='date'
					value={date.format('YYYY-MM-DD')}
					onChange={(e) => {
						const mDate = moment(e.target.value)
						if (mDate.isValid()) {
							setDate(mDate)
							onChange && onChange(mDate)
						} else {
							onChange && onChange(mDate)
						}
					}}
				/>
			</label>
		</div>
	)
}

export default ShortDatePicker
